interface Props {
  onClose: () => void;
}

export const NewMessageAlert: React.FC<Props> = ({ onClose }) => {
  // if scrollTop less than 0 (meaning user is not at bottom), show alert

  return (
    <div className="absolute top-4 right-1/2 transform translate-x-1/2">
      <button
        className="p-2 text-xs bg-cyan text-white rounded-full hover:bg-cyan/90 transition-colors duration-200"
        onClick={() => {
          const chatContainer = document.getElementById("list-chat-messages");
          if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
          }
          onClose();
        }}
      >
        新しいメッセージ ↓
      </button>
    </div>
  );
};
